export enum OrderStatesTypes {
    planned = 'PLANNED',
    awaitingVendor = 'AWAITING_VENDOR',
    awaitingSupplier = 'AWAITING_SUPPLIER',
    awaitingPurchaser = 'AWAITING_PURCHASER',
    draft = 'DRAFT',
    new = 'NEW',
    confirmed = 'CONFIRMED',
    completed = 'COMPLETED',
    rejected = 'REJECTED',
    cancelled = 'CANCELLED',
}
